import * as React from 'react'

import {ImageSkuBlock} from "@components";


export default function imageSkuColumn() {
    return {
        name: 'skuID', label: 'Product Image',
        options: {
			headerAlign: 'left',
            filter: false,
            customBodyRowRenderLite: (value, { skuName, productID, siteID, date }) => <ImageSkuBlock
                skuID={value}
                date={date}
                skuName={skuName}
                siteID={siteID}
                productID={productID}
            />
        }
    }
}